import { AIResponse, isPageResponse, isReportResponse, PageResponse, ReportResponse } from '../../models/ai-response/ai-response.model';
import { AIPreferencePageSerializer } from '../ai-preference-page/ai-preference-page-serializer.class';
import { AIReportResponseSerializer } from '../ai-report-response/ai-report-response-serializer.class';
import { Serializer } from '../resource/serializer.interface';
import { Resource } from '../resource/resource.model';

export class AIResponseSerializer implements Serializer {
    private pageSerializer = new AIPreferencePageSerializer();
    private reportSerializer = new AIReportResponseSerializer();

    fromJson(json: any): Resource {
        const intent = json.intent;

        if (intent === 'create_page') {
            const pageData = this.pageSerializer.fromJson(json.data);
            const response: PageResponse = {
                id: json.id, // Asegurarse de que la propiedad 'id' est� presente
                intent: 'create_page',
                data: pageData,
            };
            return response;
        }

        if (intent === 'generate_report') {
            const reportData = this.reportSerializer.fromJson(json.data);
            const response: ReportResponse = {
                id: json.id, // Asegurarse de que la propiedad 'id' est� presente
                intent: 'generate_report',
                data: reportData,
            };
            return response;
        }

        throw new Error(`Unsupported intent: ${intent}`);
    }

    toJson(resource: Resource): any {
        const item = resource as AIResponse;

        if (isPageResponse(item)) {
            return {
                id: item.id, // Asegurarse de que la propiedad 'id' est� presente
                intent: item.intent,
                data: this.pageSerializer.toJson(item.data),
            };
        }

        if (isReportResponse(item)) {
            return {
                id: item.id, // Asegurarse de que la propiedad 'id' est� presente
                intent: item.intent,
                data: this.reportSerializer.toJson(item.data),
            };
        }

        throw new Error(`Unsupported AIResponse type`);
    }
}
